// src/components/RetroMonitor.jsx
import React, { useEffect } from 'react';
import './RetroMonitor.css';

const RetroMonitor = () => {
  const handlePowerToggle = () => {
    const videoContainer = document.querySelector('.video-container');
    const statusLight = document.getElementById('statusLight');
    const staticOverlay = document.getElementById('staticOverlay');
    const iframe = document.querySelector('iframe');
    const terminalText = document.querySelector('.terminal-status');
    
    if (videoContainer.style.display === 'none') {
      // Turning on
      videoContainer.style.display = 'block';
      staticOverlay.style.display = 'none';
      statusLight.style.background = '#8d021f';
      statusLight.style.boxShadow = '0 0 5px rgba(141, 2, 31, 0.7)';
      if (terminalText) terminalText.textContent = '> SYSTEM STATUS: VIDEO FEED ACTIVE';
      
      // Reload the video to restart it
      const currentSrc = iframe.src;
      iframe.src = '';
      setTimeout(() => {
        iframe.src = currentSrc;
      }, 100);
    } else {
      // Turning off
      videoContainer.style.display = 'none';
      staticOverlay.style.display = 'block';
      statusLight.style.background = '#333';
      statusLight.style.boxShadow = '0 0 5px rgba(51, 51, 51, 0.5)';
      if (terminalText) terminalText.textContent = '> SYSTEM STATUS: VIDEO FEED OFFLINE';
    }
  };

  // Add effects on component mount
  useEffect(() => {
    // Add occasional subtle screen flicker
    const flickerInterval = setInterval(() => {
      if (Math.random() > 0.8) {
        const screen = document.querySelector('.monitor-screen');
        if (screen) {
          screen.style.opacity = 0.95 + (Math.random() * 0.05);
          setTimeout(() => {
            screen.style.opacity = 1;
          }, 100);
        }
      }
    }, 5000);

    // Add occasional static effect
    const staticInterval = setInterval(() => {
      if (Math.random() > 0.9) {
        const videoContainer = document.querySelector('.video-container');
        const staticOverlay = document.getElementById('staticOverlay');
        if (staticOverlay && videoContainer?.style.display !== 'none') {
          staticOverlay.style.display = 'block';
          setTimeout(() => {
            staticOverlay.style.display = 'none';
          }, 100);
        }
      }
    }, 8000);

    // Cleanup intervals on component unmount
    return () => {
      clearInterval(flickerInterval);
      clearInterval(staticInterval);
    };
  }, []);

  return (
    <section className="retro-pc-section">
      <div className="retro-pc-container">
        <div className="monitor-frame">
          <div className="biomech-detail detail-1"></div>
          <div className="biomech-detail detail-2"></div>
          <div className="biomech-detail detail-3"></div>
          
          <div className="monitor-screen">
            <div className="static-overlay" id="staticOverlay"></div>
            <div className="video-container">
              <iframe 
                width="560" 
                height="315" 
                src="https://www.youtube.com/embed/DVprerMi5Dg?si=zC8P7d0Ar_p9ya8C" 
                title="YouTube video player" 
                frameBorder="0" 
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                referrerPolicy="strict-origin-when-cross-origin" 
                allowFullScreen>
              </iframe>
            </div>
          </div>
          
          <div className="power-button" id="powerButton" onClick={handlePowerToggle}></div>
          <div className="status-light" id="statusLight"></div>
        </div>
        
        <div className="terminal-text">
          <p className="terminal-status"> SYSTEM STATUS: VIDEO FEED ACTIVE</p>
          <p> SOURCE: ARCHIVE_73/BIO-MECH/TRANS_HUMANISM</p>
          <p> WARNING: COGNITIVE INFO HAZARD DETECTED. PROCEED WITH CAUTION.</p>
          <p> <span className="blink">_</span></p>
        </div>
      </div>
    </section>
  );
};

export default RetroMonitor;